import { createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, withCtx as _withCtx, createBlock as _createBlock, createVNode as _createVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-497bed12"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "partner-area bg-style" }
const _hoisted_2 = { class: "container-fluid mw-1677" }
const _hoisted_3 = { class: "partner-wrappers bg-color-faf4f4" }
const _hoisted_4 = { class: "row align-items-center" }
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "col-lg-2" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "partner-title-2 d-block mb-3 mb-lg-0" }, " OUR MEDIA PARTNER ")
], -1))
const _hoisted_6 = { class: "col-lg-10" }
const _hoisted_7 = { class: "partner-slide-two text-center" }
const _hoisted_8 = ["src"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_swiper_slide = _resolveComponent("swiper-slide")!
  const _component_swiper = _resolveComponent("swiper")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _hoisted_5,
          _createElementVNode("div", _hoisted_6, [
            _createElementVNode("div", _hoisted_7, [
              _createVNode(_component_swiper, {
                spaceBetween: 25,
                slidesPerView: 1,
                grabCursor: true,
                centeredSlides: false,
                preventClicks: true,
                loop: true,
                autoplay: {
                  delay: 4000,
                  disableOnInteraction: false,
                  pauseOnMouseEnter: true,
                },
                breakpoints: {
                  0: {
                    slidesPerView: 2,
                  },
                  576: {
                    slidesPerView: 3,
                  },
                  768: {
                    slidesPerView: 4,
                  },
                  992: {
                    slidesPerView: 4,
                  },
                  1200: {
                    slidesPerView: 5,
                  },
                  1440: {
                    slidesPerView: 5,
                  },
                  1600: {
                    slidesPerView: 5,
                  },
                },
                class: "partner-slide-two"
              }, {
                default: _withCtx(() => [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.partners, (partner) => {
                    return (_openBlock(), _createBlock(_component_swiper_slide, {
                      key: partner.id
                    }, {
                      default: _withCtx(() => [
                        _createElementVNode("img", {
                          src: partner.image,
                          alt: "partner"
                        }, null, 8, _hoisted_8)
                      ]),
                      _: 2
                    }, 1024))
                  }), 128))
                ]),
                _: 1
              })
            ])
          ])
        ])
      ])
    ])
  ]))
}